import { useMemo } from 'react';
import { useMatch } from 'react-router-dom';

import type { NotificationScopeObject } from '@core/utils/notifications';
import { isValidUUID } from '@core/utils/uuid';

export const useNotificationScopeObject = (): NotificationScopeObject | null => {
  const quoteMatch = useMatch('/quotes/:id');
  const projectMatch = useMatch('/projects/:id');
  const activityMatch = useMatch('/activities/:id');

  const quoteID = quoteMatch?.params.id;
  const projectID = projectMatch?.params.id;
  const activityID = activityMatch?.params.id;

  return useMemo(() => {
    if (isValidUUID(quoteID)) {
      return { type: 'quote', id: quoteID };
    }
    if (isValidUUID(projectID)) {
      return { type: 'project', id: projectID };
    }
    if (isValidUUID(activityID)) {
      return { type: 'activity', id: activityID };
    }
    return null;
  }, [quoteID, projectID, activityID]);
};
